import React, { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { useRequestResetPasswordMutation } from '../../apis/mlkApi/mlk.api.hooks';
import { parseRes } from '../../apis/utils';
import { Button } from '../../components/Button/Button';
import { BaseLayout } from '../../components/Layout/Layout';
import { TextField } from '../../components/TextField/TextField';
import { emailRegexp } from '../../helpers/regexp';
import { useBack } from '../../hooks/useBack';
import { useLanguage } from '../../locale/useLanguage';
import { Routes } from '../../routes/types';

import './ForgetPasswordInsertEmailView.css';

type ForgetPassword = {
  email: string;
};

type ForgetPasswordInsertEmailViewProps = {};

export const ForgetPasswordInsertEmailView: React.FC<
  ForgetPasswordInsertEmailViewProps
> = () => {
  const [t] = useLanguage();
  const goBack = useBack();
  const history = useHistory();

  const [requestResetPassword] = useRequestResetPasswordMutation();

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<ForgetPassword>();

  const emailField = useMemo(
    () => ({
      ...register('email', {
        required: {
          value: true,
          message: t('insertEmailPasswordRecovery.invalidEmailError'),
        },
        pattern: {
          value: emailRegexp,
          message: t('insertEmailPasswordRecovery.invalidEmailError'),
        },
      }),
    }),
    [register, t]
  );

  const submit = useMemo(() => {
    return handleSubmit(({ email }) => {
      requestResetPassword(email).then((res) => {
        const { successRes, errorRes } = parseRes(res);
        if (successRes.data) {
          history.push(Routes.RecoverPasswordCheckEmail, { email });
        }

        if (errorRes.error) {
          // TODO: Handle API error
        }
      });
    });
  }, [handleSubmit, history, requestResetPassword]);

  return (
    <BaseLayout
      hasViewportHeight
      hasBack
      onBackClick={goBack}
      title={t('pageTitles.insertEmailPasswordRecovery')}
    >
      <div className="forget-password-insert-email--body">
        <div>
          <h2 className="forget-password-insert-email--title">
            {t('insertEmailPasswordRecovery.title')}
          </h2>
          <p className="forget-password-insert-email--description">
            {t('insertEmailPasswordRecovery.description')}
          </p>
          <div className="forget-password-insert-email--email">
            <TextField
              {...emailField}
              placeholder={t(
                'insertEmailPasswordRecovery.emailFieldPlaceholder'
              )}
              error={errors.email?.message}
            />
          </div>
        </div>
        <div className="forget-password-insert-email--button-container">
          <Button
            isPrimary
            label={t('insertEmailPasswordRecovery.recoverPassword')}
            onClick={submit}
          />
        </div>
      </div>
    </BaseLayout>
  );
};
